import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import { Row, Col } from 'react-flexbox-grid'
import config from 'config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon
} from '../../components'
import Styles from './IssuePage.css'

@CSSModules(Styles, {allowMultiple:true})
export default class IssueCivilianFirearms extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: 'The issue: Civilian firearms',
      description: 'Over 90% of the country supports expanding background checks to all gun sales and the majority supports increased safety regulation, but many of these same people are investing their savings in firearm manufacturers and don’t even know it.',
      url: config.domain + config.routes.issueCivilianFirearms
    }
  }

  render() {
    //
    return (
      <div styleName='page issue-gff'>
        {
          container.helmet(
            this.state.title,
            this.state.description,
            this.state.url
          )
        }
        <ContainerDivs>
          <section styleName='section'>
            <h1 styleName='issue-top-label'>
              The issue: <span>Civilian firearms</span>
            </h1>
            <h2 styleName='issue-top-headline'>
              Do you want to profit from gun violence?
            </h2>
            <h3 styleName='issue-top-copy'>
              Over 90% of the country supports expanding background checks to all gun sales and the majority supports increased safety regulation, but many of these same people are investing their savings in firearm manufacturers and don’t even know it.
            </h3>
          </section>
          <section styleName='section'>
            <Row>
              <Col xs={12} md={4}>
                <div styleName='issue-second-headline'>
                  <span style={{whiteSpace: 'nowrap'}}>&mdash;&mdash;&mdash;&mdash;</span>
                  <br/>
                  <h2>Retirement plans are invested in gun manufacturers</h2>
                </div>
              </Col>
              <Col xs={12} md={8}>
                <div styleName='issue-second-copy'>
                  <p>
                    Retirement plans are investing in firearm manufacturers and retailers who generate billions of dollars from handgun, assault rifle, and ammunition sales.
                  </p>
                  <p>
                    Asset managers like Vanguard are investing in gun manufacturers – and they’re using workers’ retirement plan savings to do so. Through Vanguard, the retirement plans of companies like Amazon and Comcast are investing millions in publicly-traded companies involved in manufacturing civilian firearms including handguns, rifles, assault weapons, and ammunition.
                  </p>
                  <p>
                    We can help build a more peaceful world by reducing the power of those who profit from violence. Investors have the power to cut ties with the corporations that make and sell the tools of gun violence, and to reinvest in ethical companies that support our communities and protect our planet.
                  </p>
                </div>
              </Col>
            </Row>
          </section>
          <section styleName='section'>
            <Row>
              <Col xs={12} md={6}>
                <div styleName='img-issue'/>
              </Col>
              <Col xs={12} md={6}>
                <div>
                  <h2 styleName='issue-focus-label'>
                    FOCUS: SUSTAINABILITY RISK
                  </h2>
                  <h3 styleName='issue-focus-headline'>
                    Civilian firearm retailers
                  </h3>
                  <div styleName='issue-focus-copy'>
                    <p>
                      Retailers selling handguns, shotguns, rifles, and ammunition — including high-capacity magazines and semiautomatic weapons known commonly as “assault rifles” — are profiting from the bloodshed of mass shootings and gun violence.
                    </p>
                    <p>
                      <Link
                        to={config.routes.companies + '#civilianfirearms'}
                        title='Companies: Civilian firearms'
                        xstrong
                      >
                        Learn more<LinkIcon />
                      </Link>
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </section>
        </ContainerDivs>
        <div styleName='section-solutions-faq-background'>
          <ContainerDivs>
            <section styleName='section section-solutions-faq'>
              <Row>
                <Col xs={12} md={6}>
                  <div styleName='section-solutions-faq-cell'>
                    <h2 styleName='issue-solutions-label'>
                      The Solutions
                    </h2>
                    <h3 styleName='issue-solutions-headline'>
                      Exclude civilian firearm manufacturers from retirement plan default options
                    </h3>
                    <div styleName='issue-solutions-copy'>
                      <p>
                        The default option offered in company retirement plans, which usually ends up with the bulk of employee contributions, should be sustainably invested and exclude civilian firearm manufacturers.
                      </p>
                    </div>
                    <div styleName='issue-faqs-link'>
                      <Link
                        to={config.routes.solutionDefaultSustainability}
                        title='Solution: Default to sustainability'
                        xstrong
                      >
                        Explore solutions<LinkIcon/>
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={6}>
                  <div styleName='section-solutions-faq-cell'>
                    <h2 styleName='issue-faqs-label'>
                      FAQs
                    </h2>
                    <div styleName='issue-faqs-headline'>
                      Answers to common questions about how retirement plans and asset managers are financing the gun violence.
                    </div>
                    <div styleName='issue-faqs-item'>
                      <Link
                        to={config.routes.faqs + '#do-i-have-to-sacrifice-returns-in-order-to-invest-sustainably-'}
                        title='Do I have to sacrifice returns in order to invest sustainably?'
                        xstrong
                      >
                        Do I have to sacrifice returns in order to invest sustainably?
                      </Link>
                    </div>
                    <div styleName='issue-faqs-item'>
                      <Link
                        to={config.routes.faqs + '#why-should-retirement-plans-add-a-sustainable-investment-option-'}
                        title='Why should retirement plans add a sustainable investment option?'
                        xstrong
                      >
                        Why should retirement plans add a sustainable investment option?
                      </Link>
                    </div>
                    <div styleName='issue-faqs-link'>
                      <Link
                        to={config.routes.faqs}
                        title='FAQs'
                        xstrong
                      >
                      View all >>
                      </Link>
                    </div>
                  </div>
                </Col>
              </Row>
            </section>
            <br/>
            <br/>
          </ContainerDivs>
        </div>
      </div>
    )
  }
}
